import {
  RoleAssignmentUpdates,
  SecurityGroupRoleAssignmentsReadModel,
  StringReferenceReadModel,
} from "../../../../../../@api";

export interface IManageSecurityGroupFormValues {
  securityGroup: StringReferenceReadModel | null;
  assignedRoleIds: string[];
}

export interface IEditSecurityGroupRoleAssignmentsReadModel extends SecurityGroupRoleAssignmentsReadModel {
  assignedRoles: StringReferenceReadModel[];
}

export interface IManageSecurityGroupDialogState {
  isValid: boolean;
  hasPendingChanges: boolean;
  isUpdating: boolean;
  formData?: IManageSecurityGroupFormValues;
}

export type IFormValuesWithSecurityGroup = IManageSecurityGroupFormValues & {
  securityGroup: NonNullable<IManageSecurityGroupFormValues["securityGroup"]>;
};

export const createRoleAssignmentRequest = (
  formData: IFormValuesWithSecurityGroup,
  existing?: SecurityGroupRoleAssignmentsReadModel,
): { [key: string]: RoleAssignmentUpdates } => {
  const addedRoles = existing
    ? formData.assignedRoleIds.filter(id => !existing.assignedRoleIds.includes(id))
    : formData.assignedRoleIds;

  const removedRoles = existing ? existing.assignedRoleIds.filter(id => !formData.assignedRoleIds.includes(id)) : [];

  return {
    [formData.securityGroup.id!]: {
      addedRoles,
      removedRoles,
    },
  };
};
